import { Link } from "react-router-dom";
import useMidpointMediaAdminView from "../../../hooks/useMidpointMediaAdminView";
import "../../../styles/midpointMediaAdmin.css";

export default function MidpointMediaAdminPeoplePage() {
  const { paths } = useMidpointMediaAdminView();
  return (
    <div className="mm-admin-page">
      <header>
        <p className="mm-admin-kicker">People</p>
        <h1>Employees and coverage</h1>
        <p className="mm-admin-lead">
          Manage who can sign in to this workspace, then plan weekly coverage. Accounts are live.
          Schedules are a working demo until a shift table is wired.
        </p>
      </header>
      <section className="mm-admin-grid" style={{ gridTemplateColumns: "1fr 1fr" }}>
        <article className="mm-admin-card">
          <h2>Accounts</h2>
          <p className="mm-admin-lead">
            Invite operators, set roles, and deactivate access. This uses the existing client
            identity layer for Midpoint Media.
          </p>
          <Link className="btn btn-primary" to={`${paths.base}/people/accounts`}>
            Manage accounts
          </Link>
        </article>
        <article className="mm-admin-card">
          <h2>Schedules</h2>
          <p className="mm-admin-lead">
            A weekly coverage board for remote staff (Venezuela hiring, support, engineering).
          </p>
          <Link className="btn btn-secondary" to={`${paths.base}/people/schedules`}>
            Open schedules
          </Link>
        </article>
      </section>
    </div>
  );
}
